import PaymentMethodService from '../../services/PaymentMethodService';
import paymentMethodUseCase from './paymentMethodUseCase';

const paymentMethodFactory = paymentMethodUseCase({
  PaymentMethodService: PaymentMethodService(),
});

export default paymentMethodFactory;
